const key = "allow-token-management";

const applicable = (resp) => {
	return resp.config.url.match(/api\/forms\/[0-9]+\/security$/);
};

const modify = (resp) => {
	if(resp.data.Success !== true || !resp.data.Data) {
		return;
	}
	
	const assigned = resp.data.Data.Assigned;
	const role = resp.data.Data.Roles.find(r => r.Code === assigned[0].Code);

	const allowReadTokens = { Effect: "Allow", Path: "/types/DEALER/tokens/*/read" };
	const allowDeactivate = { Effect: "Allow", Path: "/tokens/*/deactivate" };
	role.Actions.push(allowReadTokens, allowDeactivate);

};

export const allowTokenManagement = [key, applicable, modify];